import StickyHeader from '../../buyer-experience/common/has-a-sticky';

type FeaturesParams = { showText: string; hideText: string; showAllText: string; hideAllText: string; useExpandAll: boolean; useAccordionStyle: boolean };

export default class FeaturesTable {
  params: FeaturesParams;
  useExpandAll: boolean;
  expandAllButton: Element | null;
  clickyThingies: NodeListOf<Element>;

  constructor(domRoot: HTMLElement, params: FeaturesParams) {
    this.params = params;

    this.useExpandAll = params.useExpandAll;
    this.expandAllButton = domRoot.querySelector('.show-hide-all');
    this.clickyThingies = domRoot.querySelectorAll('.feature-name');
    this.init();
  }

  init() {
    this.bindEvents();
    this.expandByHash(true);
  }

  expandEvent(feature: Element, showAllText?: string) {
    const table = feature.nextElementSibling;
    const toggleText = feature.querySelector('.toggle');
    const circularIconSpan = toggleText?.querySelector('.circular-icon');

    const showText = this.params.showText ? this.params.showText : "Show";
    const hideText = this.params.hideText ? this.params.hideText : "Hide";

    let isActive = table?.classList.contains('active') || false;

    if (showAllText) {
      isActive = showAllText == "hideAllItems";
    }

    // Assert that selectors returned elements and not null (to staify TS type enforcement)
    if (!toggleText || !table) {
      return;
    }

    if (!isActive) {
      this.isDisplayHideToggle(toggleText, hideText, circularIconSpan);
      table.classList.add('active');
      feature.classList.add("active");
      feature.setAttribute("data-label", hideText);
    } else {
      this.isDisplayShowToggle(toggleText, showText, circularIconSpan);
      table.classList.remove('active');
      feature.classList.remove("active");
      feature.setAttribute("data-label", showText);
    }

    this.setAriaLabel(feature);
  }

  isDisplayHideToggle(toggleText, hideText, circularIconSpan) {
    if (this.params.useAccordionStyle) {
      if(circularIconSpan.classList.contains('plus')) {
        circularIconSpan.classList.remove('plus');
      }
      if(!circularIconSpan.classList.contains('minus')) {
        circularIconSpan.classList.add('minus');
      }
    } else {
      toggleText.innerHTML = hideText;
    }
  }

  isDisplayShowToggle(toggleText, showText, circularIconSpan) {
    if (this.params.useAccordionStyle) {
      if(circularIconSpan.classList.contains('minus')) {
        circularIconSpan.classList.remove('minus');
      }
      if(!circularIconSpan.classList.contains('plus')) {
        circularIconSpan.classList.add('plus');
      }
    } else {
      toggleText.innerHTML = showText;
    }
  }

  expandByHash(initialization?: boolean) {
    for (let i = 0; i < this.clickyThingies.length; i++) {
      if (window.location.hash == '#' + this.clickyThingies[i].id) {
        this.expandEvent(this.clickyThingies[i]);
        window.scrollTo(0, window.scrollY - StickyHeader.height());
        if (initialization) {
          /* on initalization, make a second call (this combats the loading jank) */
          setTimeout(() => {
            window.scrollTo(0, window.scrollY - StickyHeader.height() - 10);
          }, 50);
        }
        break;
      }
    }
  }

  setAriaLabel(featureNameElement) {
    let ariaLabel;
    const clickyThingiesLabel = featureNameElement.querySelector('.label')?.innerText;
    const clickyThingiesToggle = featureNameElement.querySelector('.toggle')?.innerText;
    if (clickyThingiesToggle) {
      ariaLabel = `${clickyThingiesLabel} ${clickyThingiesToggle}`;
    } else {
      const circularIconClassList = featureNameElement.querySelector('.toggle')?.querySelector('.circular-icon')?.classList;
      if (circularIconClassList?.contains('plus')) {
        ariaLabel = `${clickyThingiesLabel} plus`;
      } else {
        ariaLabel = `${clickyThingiesLabel} minus`;
      }
    }
    featureNameElement.setAttribute("aria-label", ariaLabel);
  }

  bindEvents() {
    window.addEventListener("hashchange", () => {
      this.expandByHash();
    });

    for (let i = 0; i < this.clickyThingies.length; i++) {
      this.setAriaLabel(this.clickyThingies[i]);
      this.clickyThingies[i].addEventListener("click", (e) => {
        e.preventDefault();
        e.cancelBubble = true;
        e.target && this.expandEvent(e.target as Element);
      });

      // Bind copy header URL to clipboard and "copied" tooltip functionality
      this.clickyThingies[i].querySelectorAll('.copy-link').forEach((copyLink) => {
        copyLink.addEventListener("click", () => {
          const clickyThingyId = this.clickyThingies[i].id;
          const headerAnchorUrl = `${window.location.href.replace(/#.*/i, '')}#${encodeURIComponent(clickyThingyId)}`;
  
          navigator.clipboard.writeText(headerAnchorUrl).then(() => {

            // Show success label (simple, no state management, use naive timeouts)
            copyLink.classList.add('success');
            setTimeout(() => {
              copyLink.classList.remove('success');
            }, 3000);
          });
        });
      });
    }
    if (this.useExpandAll) {
      this.expandAllButton?.addEventListener("click", (e) => {
        const targetElement = e.target as HTMLElement;
        targetElement.classList.toggle("showing-all");
        const shouldShow = targetElement.classList.contains("showing-all");
        const newLabel = shouldShow ? this.params.hideAllText : this.params.showAllText;
        targetElement.innerHTML = newLabel;
        targetElement.setAttribute('data-label', newLabel);

        for (let i = 0; i < this.clickyThingies.length; i++) {
          this.expandEvent(this.clickyThingies[i], shouldShow ? "activateAllItems" : "hideAllItems");
        }
      });
    }
  }

}
